var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeader6ShapeB(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.41 730.14L0 730Q.62 370.54.13 11.06V0h1920v395.88c0 33.48 9.67 73.48-3.28 105.2-180.64-90.05-381.53-71.29-567.12-5.18-175.52 62.52-337.11 159.58-512.46 222.59C567.74 815.34 272 823.67.41 730.14z",
    fill: "#d7dcea",
    opacity: 0.3
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOTIwIDEwODAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZDdkY2VhO29wYWNpdHk6MC4zO308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0uNDEsNzMwLjE0LDAsNzMwUS42MiwzNzAuNTQuMTMsMTEuMDZWMGgxOTIwVjM5NS44OGMwLDMzLjQ4LDkuNjcsNzMuNDgtMy4yOCwxMDUuMi0xODAuNjQtOTAuMDUtMzgxLjUzLTcxLjI5LTU2Ny4xMi01LjE4LTE3NS41Miw2Mi41Mi0zMzcuMTEsMTU5LjU4LTUxMi40NiwyMjIuNTlDNTY3Ljc0LDgxNS4zNCwyNzIsODIzLjY3LjQxLDczMC4xNFoiLz48L3N2Zz4=";
export { SvgHeader6ShapeB as ReactComponent };